import { getTheme, Label, Stack } from '@fluentui/react';

const theme = getTheme();
const styles = {
	root: {
		position: 'absolute',
		background: `linear-gradient(-45deg, ${theme.palette.neutralPrimary}, ${theme.palette.neutralDark})`,
		width: '100vw',
		height: '100vh',
		zIndex: '100',
		display: 'flex',
		alignContent: 'center',
		justifyContent: 'center'
	}
} as const;

const FullScreenError = ({title,subtitle}:{title:string,subtitle:string}) => {
	return(
		<Stack styles={styles}>
			<div style={{alignSelf: "center",textAlign: "center"}}>
				<Label style={{color: theme.palette.neutralTertiaryAlt}}>{title}</Label>
				<Label style={{color: theme.palette.neutralLight}}>{subtitle}</Label>
			</div>
		</Stack>
	)
}

export default FullScreenError;